import Vue from "vue";
import VueRouter from "vue-router";
import IndexView from "../views/indexView/indexView.vue";
import AboutView from "../views/aboutView/aboutView.vue";
import AboutUs from "../views/aboutView/aboutUs.vue";
import test from "../views/test/test.vue";
import DownloadView from "../views/downloadView/downloadView.vue";
import SettingView from "../views/settingView/settingView.vue";
import NoFound from "../views/404.vue";
import forgetPwd from "../views/forgetPwdView/forgetPwd.vue";
import privacyView from "../views/privacyView/privacyView.vue";
import agreementView from "../views/agreementView/agreementView.vue";
import noticeView from "../views/noticeView/noticeView.vue";
import articleView from "../views/articleView/articleView.vue";
import purchaseView from "../views/purchaseView/purchaseView.vue";
import activityView from "../views/activityView/activityView.vue";
import helpDocs from "../views/helpDocs/helpDocs.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "IndexView",
    component: IndexView
  },
  {
    path: "/about",
    name: "AboutView",
    component: AboutView
  },
  {
    path: "/aboutUs",
    name: "AboutUs",
    component: AboutUs
  },
  {
    path: "/helpDocs",
    name: "helpDocs",
    component: noticeView
  },
  {
    path: "/activity",
    name: "activityView",
    component: activityView
  },
  {
    path: "/test",
    name: "test",
    component: test
  },
  {
    path: "/download",
    name: "DownloadView",
    component: DownloadView
  },
  {
    path: "/forgetPassword",
    name: "forgetPwd",
    component: forgetPwd
  },
  {
    path: "/setting",
    name: "SettingView",
    component: SettingView
  },
  {
    path: "/privacy",
    name: "privacyView",
    component: privacyView
  },
  {
    path: "/agreement",
    name: "agreementView",
    component: agreementView
  },
  {
    path: "/notice",
    name: "noticeView",
    component: noticeView
  },
  {
    path: "/article",
    name: "articleView",
    component: articleView
  },
  {
    path: "/*",
    name: "NoFound",
    component: NoFound
  },
  {
    path: "/purchase",
    name: "purchaseView",
    component: purchaseView
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path === "/setting") {
    try {
      if (
        localStorage.getItem("userMsg") !== "{}" &&
        localStorage.getItem("userMsg") !== null
      ) {
        next();
      } else {
        next("/notLoggedIn");
      }
    } catch (error) {
      next("/notLoggedIn");
    }
  } else {
    next();
  }
});
export default router;
